"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _utils = require("../utils");
var _popup = require("../mixins/popup");
var _button = _interopRequireDefault(require("../button"));
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */

var _use = (0, _utils.use)('dialog'),
  sfc = _use[0],
  bem = _use[1],
  t = _use[2];
var _default = sfc({
  mixins: [_popup.PopupMixin],
  props: {
    title: String,
    message: String,
    business: Boolean,
    wider: Boolean,
    transparent: Boolean,
    className: null,
    callback: Function,
    beforeClose: Function,
    messageAlign: String,
    promptMode: Boolean,
    promptType: {
      type: String,
      default: 'text'
    },
    promptDefaultText: String,
    promptPlaceholder: String,
    confirmButtonText: String,
    cancelBtnProps: Object,
    btnProps: Object,
    cancelButtonText: String,
    confirmButtonClass: String,
    cancelButtonClass: String,
    fade: Boolean,
    showClose: Boolean,
    showCancelButton: Boolean,
    hideFooter: {
      type: Boolean,
      default: false
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    },
    overlayClass: {
      type: String,
      default: 'z-dialog__overlay'
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    lineFeed: {
      type: Boolean,
      default: false
    },
    showTopClose: {
      type: Boolean,
      default: false
    },
    forbidBtnLoading: Boolean
  },
  data: function data() {
    return {
      input: this.promptDefaultText || '',
      loading: {
        confirm: false,
        cancel: false
      }
    };
  },
  watch: {
    value: function value(val) {
      var _this = this;
      if (val && this.promptMode) {
        this.input = this.promptDefaultText || '';
        setTimeout(function () {
          _this.$refs.contentInput.focus();
        }, 300);
      }
    }
  },
  methods: {
    onClickOverlay: function onClickOverlay() {
      this.handleAction('overlay');
    },
    handleAction: function handleAction(action) {
      var _this2 = this;
      var param = action === 'confirm' && this.promptMode && this.input;

      // close event will emit in popup mixin
      if (action !== 'close') {
        this.$emit(action, param);
      }
      var loadingState = false;
      if (this.beforeClose) {
        if (!this.forbidBtnLoading) {
          this.loading[action] = true;
        } else {
          loadingState = true;
        }
        this.beforeClose(action, function (state) {
          if (state !== false && (loadingState || _this2.loading[action])) {
            _this2.onClose(action, param);
          }
          _this2.loading.confirm = false;
          _this2.loading.cancel = false;
        }, param);
      } else {
        this.onClose(action, param);
      }
    },
    onClose: function onClose(action, param) {
      this.close();
      if (this.callback) {
        this.callback(action, param);
      }
    },
    renderContent: function renderContent() {
      var _this3 = this,
        _bem;
      var h = this.$createElement;
      var title = this.title,
        message = this.message,
        messageAlign = this.messageAlign,
        promptMode = this.promptMode;
      var hasButton = this.showCancelButton || this.showConfirmButton;
      var content = this.slots();
      return h("div", {
        "class": bem('content', {
          'no-title': !title,
          'no-button': !hasButton
        })
      }, [promptMode && h("div", {
        "class": bem('input', {
          'no-title': !title
        })
      }, [this.promptType === 'textarea' ? h("textarea", (0, _babelHelperVueJsxMergeProps.default)([{
        "on": {
          "input": function input($event) {
            if ($event.target.composing) return;
            _this3.input = $event.target.value;
          }
        },
        "ref": 'contentInput',
        "attrs": {
          "placeholder": this.promptPlaceholder
        },
        "domProps": {
          "value": _this3.input
        }
      }, {
        directives: [{
          name: "model",
          value: _this3.input,
          modifiers: {}
        }]
      }])) : h("input", (0, _babelHelperVueJsxMergeProps.default)([{
        "on": {
          "input": function input($event) {
            if ($event.target.composing) return;
            _this3.input = $event.target.value;
          }
        },
        "ref": 'contentInput',
        "attrs": {
          "type": this.promptType,
          "placeholder": this.promptPlaceholder
        },
        "domProps": {
          "value": _this3.input
        }
      }, {
        directives: [{
          name: "model",
          value: _this3.input,
          modifiers: {}
        }]
      }]))]), !promptMode && content, !content && message && h("div", {
        "domProps": {
          "innerHTML": message
        },
        "class": bem('message', (_bem = {
          'no-title': !title
        }, _bem[messageAlign] = messageAlign, _bem))
      })]);
    },
    renderButton: function renderButton() {
      var _this4 = this;
      var h = this.$createElement;
      var lineFeed = this.lineFeed,
        business = this.business,
        hideFooter = this.hideFooter;
      var hasTwoButtons = this.showCancelButton && this.showConfirmButton;
      if (!!hideFooter) return;
      if (business) {
        return this.renderBusinessButton();
      }
      return h("div", {
        "class": [bem('footer', {
          lineFeed: lineFeed
        })]
      }, [this.showConfirmButton && h(_button.default, {
        "props": Object.assign({}, Object.assign({
          size: 'large'
        }, this.btnProps)),
        "attrs": {
          "hairline": false,
          "btnClass": [bem('confirm'), this.confirmButtonClass, {
            'z-hairline--left': hasTwoButtons && !lineFeed
          }],
          "loading": this.loading.confirm,
          "text": this.confirmButtonText || t('confirm')
        },
        "on": {
          "click": function click() {
            return _this4.handleAction('confirm');
          }
        }
      }), this.showCancelButton && h(_button.default, {
        "props": Object.assign({}, Object.assign({
          size: 'large'
        }, this.cancelBtnProps)),
        "attrs": {
          "hairline": false,
          "btnClass": [bem('cancel'), this.cancelButtonClass, {
            'z-hairline--top': hasTwoButtons && lineFeed
          }],
          "loading": this.loading.cancel,
          "text": this.cancelButtonText || t('cancel')
        },
        "on": {
          "click": function click() {
            return _this4.handleAction('cancel');
          }
        }
      })]);
    },
    renderBusinessButton: function renderBusinessButton() {
      var _this5 = this;
      var h = this.$createElement;
      var lineFeed = this.lineFeed;
      var noButton = !this.showConfirmButton && !this.showCancelButton;
      return h("div", {
        "class": [bem('business-footer', {
          noButton: noButton,
          lineFeed: lineFeed
        })]
      }, [this.showConfirmButton && h(_button.default, {
        "props": Object.assign({}, Object.assign({
          size: 'large',
          type: 'primary'
        }, this.btnProps)),
        "attrs": {
          "btnClass": [bem('confirm'), this.confirmButtonClass],
          "loading": this.loading.confirm,
          "text": this.confirmButtonText || t('confirm')
        },
        "on": {
          "click": function click() {
            return _this5.handleAction('confirm');
          }
        }
      }), this.showCancelButton && h(_button.default, {
        "props": Object.assign({}, Object.assign({
          size: 'large'
        }, this.cancelBtnProps)),
        "attrs": {
          "type": lineFeed ? 'text' : 'cancel',
          "btnClass": [bem('cancel'), this.cancelButtonClass],
          "loading": this.loading.cancel,
          "text": this.cancelButtonText || t('cancel')
        },
        "on": {
          "click": function click() {
            return _this5.handleAction('cancel');
          }
        }
      })]);
    },
    renderClose: function renderClose() {
      var _this6 = this;
      var h = this.$createElement;
      return this.showClose && h("div", {
        "on": {
          "click": function click() {
            return _this6.handleAction('close');
          }
        },
        "class": [bem('close'), this.business && bem('business-close')]
      }, [h("z-icon", {
        "attrs": {
          "class-prefix": "zziconfont",
          "name": "close-text-o"
        }
      })]);
    }
  },
  render: function render(h) {
    var _this7 = this;
    if (!this.shouldRender) {
      return;
    }
    var title = this.title,
      wider = this.wider,
      transparent = this.transparent;
    var top = this.slots('top');
    var Top = top && h("div", {
      "class": bem('top')
    }, [top]);
    var Title = title && h("div", {
      "class": bem('header', {
        'top': top
      }),
      "domProps": {
        "innerHTML": title
      }
    });
    return h("transition", {
      "attrs": {
        "name": this.fade ? 'z-fade' : 'z-zoom'
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": [bem({
        wider: wider,
        transparent: transparent
      }), this.className]
    }, [Top, Title, this.renderContent(), !!this.slots('btn') ? h("div", {
      "class": "z-dialog__bottom-slot"
    }, [this.slots('btn')]) : this.renderButton(), this.renderClose(), this.showTopClose ? h("img", {
      "on": {
        "click": function click() {
          return _this7.handleAction('close');
        }
      },
      "class": bem('cloneimg'),
      "attrs": {
        "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAAGFBMVEUAAACampq1tbWampqZmZmbm5ubm5uZmZny18HSAAAAB3RSTlMAtgbWzn9mgs8TywAAAMxJREFUSMft1T0OwjAMhmHE3wFYWNsbsLAzMSNxAQYuwPRdH3V6pXh4pVTqFI92+0RNE3s3YsSG8b1PNbl/P9vUObnUB+fk06SOyW8q4DV5NLlDFrKCuTW5UxaygnmVVSo583LJyrukDSQvIAUDqQhIyUBqAlI0kKqAlA2kbiAkoJCAQgIKCSgkoJCAQgIaCegPrl3aP8a3xzd85S/0Q+HHzA+ug0Lq5fLr6g1AQCGlSWnb622k3pq92XeODx9IPuI6h6aPYR/sI0ZsF3/0GaXBgkMzbgAAAABJRU5ErkJggg=="
      }
    }) : ''])]);
  }
});
exports.default = _default;